module.exports = __webpack_public_path__ + "img/features-content-img-3-ua.c2a98f1f.png";